const OPTION_SELECTOR = "[data-dropdown-option-label]";
const SEARCH_INPUT_SELECTOR = "[data-dropdown-autocomplete]";

export class PbDropdownKeyboard {
  constructor(dropdown) {
    this.dropdown = dropdown;
    this.dropdownElement = dropdown.element;
    this.options = Array.from(
      (dropdown.target || this.dropdownElement).querySelectorAll(OPTION_SELECTOR),
    );
    this.focusedOptionIndex = -1;
    this.searchInput = this.dropdownElement.querySelector(
      SEARCH_INPUT_SELECTOR
    );
    // Store bound handlers for cleanup
    this.handleKeyDownBound = this.handleKeyDown.bind(this);
    this.handleSearchInputBound = () => {
      if (!this.dropdown.isAsync) this.openDropdownIfClosed();
    };
    this.init();
  }

  init() {
    this.dropdownElement.addEventListener(
      "keydown",
      this.handleKeyDownBound
    );
    if (this.searchInput) {
      this.searchInput.addEventListener("input", this.handleSearchInputBound);
    }
  }

  disconnect() {
    // Remove keydown listener
    if (this.dropdownElement && this.handleKeyDownBound) {
      this.dropdownElement.removeEventListener(
        "keydown",
        this.handleKeyDownBound
      );
    }
    
    // Remove search input listener
    if (this.searchInput && this.handleSearchInputBound) {
      this.searchInput.removeEventListener("input", this.handleSearchInputBound);
    }
  }

  getVisibleOptions() {
    // We only want to return the options that are visible
    const scope = this.dropdown.target || this.dropdownElement;
    return Array.from(scope.querySelectorAll(OPTION_SELECTOR)).filter(
      
      (opt) => opt.style.display !== "none" && opt.dataset.dropdownOptionDisabled !== "true"
    ,
    );
  }

  openDropdownIfClosed() {
    if (this.dropdown.isDisabled) return;

    if (!this.dropdown.target.classList.contains("open")) {
      this.dropdown.showElement(this.dropdown.target);
      this.dropdown.updateArrowDisplay(true);
    }
  }

  handleKeyDown(event) {
    if (this.dropdown.isDisabled) return;
    const isComposing = event.isComposing || event.keyCode === 229;
    if (this.dropdown.allowOptionCreation && isComposing) return;

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        if (!this.dropdown.target.classList.contains("open")) {
          this.dropdown.showElement(this.dropdown.target);
          this.dropdown.updateArrowDisplay(true);
        }
        this.moveFocus(1);
        break;
      case "ArrowUp":
        event.preventDefault();
        this.moveFocus(-1);
        break;
      case "Enter":
        event.preventDefault();
        if (this.focusedOptionIndex !== -1) {
          this.selectOption();
        } else {
          if (!this.dropdown.target.classList.contains("open")) {
            this.dropdown.showElement(this.dropdown.target);
            this.dropdown.updateArrowDisplay(true);
          }
        }
        break;
      case "Escape":
        this.dropdown.hideElement(this.dropdown.target);
        break;
      case "Tab":
        this.dropdown.hideElement(this.dropdown.target);
        this.dropdown.updateArrowDisplay(false);
        this.dropdown.resetFocus();
        break;
      case "Backspace":
        if (this.searchInput) {
          setTimeout(() => {
            if (this.searchInput.value.trim() === "") {
              this.dropdown.handleBackspaceClear();
            }
          }, 0); 
        }
        break;
      default:
        break;
    }
  }

moveFocus(direction) {
    const scope = this.dropdown.target || this.dropdownElement;
    const allOptions = Array.from(scope.querySelectorAll(OPTION_SELECTOR));
    const visible = this.getVisibleOptions();
    if (!visible.length) return;

    if (this.focusedOptionIndex !== -1) {
      allOptions[this.focusedOptionIndex].classList.remove(
        "pb_dropdown_option_focused"
      );
    }

    const prevVisibleIndex =
      this.focusedOptionIndex === -1
        ? -1
        : visible.indexOf(allOptions[this.focusedOptionIndex]);

    const nextVisibleIndex =
      (prevVisibleIndex + direction + visible.length) % visible.length;

    const nextEl = visible[nextVisibleIndex];
    nextEl.classList.add("pb_dropdown_option_focused");

    this.focusedOptionIndex = allOptions.indexOf(nextEl);
  }


  selectOption() {
    if (this.dropdown.isDisabled) return;

    const scope = this.dropdown.target || this.dropdownElement;
    const allOptions = Array.from(scope.querySelectorAll(OPTION_SELECTOR));
    if (this.focusedOptionIndex < 0) return;

    const optionEl = allOptions[this.focusedOptionIndex];
    if (optionEl.dataset.dropdownOptionDisabled === "true") return;

    this.dropdown.handleOptionClick({ target: optionEl });
    if (!this.dropdown.isAsync && !this.dropdown.allowOptionCreation) this.dropdown.toggleElement(this.dropdown.target);
    this.dropdown.updateClearButton();
  }
}
